import MuiGrid from "@mui/material/Grid";

export default function Grid(props) {
  return <MuiGrid {...props} />;
}
